import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { GlassCard } from '../shared';
import { quranApi } from '../../services/api';

/**
 * RecentSurahsCarousel — affiche un carousel horizontal des sourates consultées récemment
 */
export const RecentSurahsCarousel = () => {
  const [surahs, setSurahs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRecentSurahs = async () => {
      try {
        // Récupérer depuis localStorage
        const saved = localStorage.getItem('recentSurahs');
        if (saved) {
          const recent = JSON.parse(saved).slice(0, 6);
          
          // Fetch metadata de chaque sourate
          const data = await quranApi.list();
          const surahsMap = new Map(data.data.map(s => [s.number, s]));
          
          const enriched = recent.map(n => surahsMap.get(n)).filter(Boolean);
          setSurahs(enriched);
        }
      } catch (err) {
        console.error('Error fetching recent surahs:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchRecentSurahs();
  }, []);

  if (loading || surahs.length === 0) return null;

  return (
    <div data-testid="recent-surahs-carousel">
      <div className="mb-3">
        <h3 className="text-sm uppercase tracking-wider text-text-muted font-medium">
          Consultés récemment
        </h3>
      </div>
      
      <div className="overflow-x-auto pb-2 -mx-4 px-4">
        <div className="flex gap-3">
          {surahs.map((surah) => (
            <Link
              key={surah.number}
              to={`/quran/${surah.number}`}
              className="flex-shrink-0 w-24 aspect-square bg-gradient-to-br from-primary/20 to-primary/5 
                       rounded-lg flex flex-col items-center justify-center hover:from-primary/30 
                       transition-all active:scale-95 border border-primary/20"
              data-testid={`recent-surah-${surah.number}`}
            >
              <span className="font-arabic text-lg text-text-primary text-center px-2 line-clamp-2">
                {surah.nameArabic}
              </span>
              <span className="text-xs text-text-muted mt-1">{surah.number}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecentSurahsCarousel;
